<template>
  <div class="flex items-center justify-between py-4 border-b border-secondary-200 dark:border-secondary-700 last:border-0">
    <div class="flex items-center space-x-4 flex-1">
      <div class="flex-shrink-0">
        <div class="h-12 w-12 rounded-lg bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center">
          <component :is="moduleIcon" class="h-6 w-6 text-primary-600 dark:text-primary-400" />
        </div>
      </div>
      <div class="flex-1">
        <h3 class="text-sm font-medium text-secondary-900 dark:text-white">
          {{ module.name }}
        </h3>
        <p class="text-sm text-secondary-600 dark:text-secondary-400">
          {{ module.description }}
        </p>
      </div>
    </div>
    <div class="ml-4">
      <Toggle :model-value="enabled" @update:model-value="handleToggle" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Toggle from '@/Components/Common/Toggle.vue';
import {
  TicketIcon,
  WrenchScrewdriverIcon,
  ExclamationTriangleIcon,
} from '@heroicons/vue/24/outline';

const props = defineProps({
  module: {
    type: Object,
    required: true,
  },
  enabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle']);

const iconMap = {
  TicketIcon,
  WrenchScrewdriverIcon,
  ExclamationTriangleIcon,
};

const moduleIcon = computed(() => {
  return iconMap[props.module.icon] || TicketIcon;
});

const handleToggle = (value) => {
  emit('toggle', props.module.id);
};
</script>
